(function() {
  'use strict';

  function initStepsToUse(el) {
    if (!el) return;

    var tabButtons = el.querySelectorAll('.steps-to-use__tab-button');
    var tabContents = el.querySelectorAll('.steps-to-use__tab-content');

    // Tab switching functionality
    function switchTab(targetTabId) {
      // Remove active class from all buttons and contents
      tabButtons.forEach(function(button) {
        button.classList.remove('active');
      });
      tabContents.forEach(function(content) {
        content.classList.remove('active');
      });

      // Add active class to clicked button
      var clickedButton = el.querySelector('[data-tab="' + targetTabId + '"]');
      if (clickedButton) {
        clickedButton.classList.add('active');
      }

      // Show corresponding content
      var targetContent = el.querySelector('[data-tab-content="' + targetTabId + '"]');
      if (targetContent) {
        targetContent.classList.add('active');
        
        // Reinitialize swiper if it exists in the active tab
        var swiperContainer = targetContent.querySelector('.swiper');
        if (swiperContainer && swiperContainer.swiper) {
          swiperContainer.swiper.update();
        }
      }
    }

    // Add click event listeners to tab buttons
    tabButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        var tabId = button.getAttribute('data-tab');
        if (tabId) {
          switchTab(tabId);
        }
      });
    });

    // Initialize first tab as active if none is active
    var hasActiveTab = false;
    for (var i = 0; i < tabButtons.length; i++) {
      if (tabButtons[i].classList.contains('active')) {
        hasActiveTab = true;
        break;
      }
    }
    if (!hasActiveTab && tabButtons.length > 0) {
      var firstTabId = tabButtons[0].getAttribute('data-tab');
      if (firstTabId) {
        switchTab(firstTabId);
      }
    }
  }

  // Initialize on DOM ready
  function init() {
    var elements = document.querySelectorAll('[data-module="steps-to-use"]');
    elements.forEach(function(el) {
      initStepsToUse(el);
    });
  }

  // Initialize immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on section load (for Shopify theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = document.querySelector('#shopify-section-' + e.detail.sectionId);
      if (section) {
        var moduleEl = section.querySelector('[data-module="steps-to-use"]');
        if (moduleEl) {
          initStepsToUse(moduleEl);
        }
      }
    });
  }
})();

